["/login","/register","/login/pw/request","/verifikasi-otp","/login/pw/change","/verifikasi-otp","/login-password","/login-email"]